import { fetcher } from "helpers/fetcher";

import { TGetKanbanTicketsReq, TGetKanbanTicketsRes } from "./types";
import { LanguageType } from "types/index";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getKanbanTickets = async (
  payload?: TGetKanbanTicketsReq,
  language: LanguageType = "en",
  signal?: AbortSignal
) => {
  return await fetcher<TGetKanbanTicketsRes, TGetKanbanTicketsReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_KANBAN_TICKETS,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_KANBAN_TICKETS.version,
        [API_HEADER.BU_ID]: payload?.buId,
        [API_HEADER.LANGUAGE]: language,
      },
      data: payload?.data,
      urlData: { pipelineSlug: payload?.path?.pipelineSlug },
      signal,
    }
  );
};

export const queryGetKanbanTickets = async (
  payload?: TGetKanbanTicketsReq,
  language: LanguageType = "en",
  signal?: AbortSignal
) => {
  return (await getKanbanTickets(payload, language, signal)).data;
};

queryGetKanbanTickets._key = (
  payload?: TGetKanbanTicketsReq,
  language: LanguageType = "en"
) => [ENDPOINT.MANAGEMENT.GET_KANBAN_TICKETS.url, payload, language];
